import React from 'react';
import { CLAP_ICON_ACTIVE, CLAP_ICON_DEFAULT } from '../../data/clapIconAssets';

const SIZE_CLASS = {
  xs: 'h-3.5 w-3.5',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-7 w-7',
  xl: 'h-8 w-8',
  '2xl': 'h-9 w-9',
};

const SIZE_PX = {
  xs: 14,
  sm: 16,
  md: 20,
  lg: 28,
  xl: 32,
  '2xl': 36,
};

/**
 * Icons8 clapping hands - pale when idle, yellow when active.
 * @param {{ active?: boolean; size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'; className?: string }} props
 */
export function ClapHandsImage({ active = false, size = 'sm', className = '' }) {
  const dim = SIZE_CLASS[size] ?? SIZE_CLASS.sm;
  const px = SIZE_PX[size] ?? SIZE_PX.sm;

  return (
    <img
      src={active ? CLAP_ICON_ACTIVE : CLAP_ICON_DEFAULT}
      alt=""
      aria-hidden
      draggable={false}
      className={`shrink-0 object-contain ${dim} ${className}`.trim()}
      width={px}
      height={px}
    />
  );
}

export default ClapHandsImage;
